// extracted by mini-css-extract-plugin
export default {"fitting":"WinterWheelFitting__fitting--wd4AG","description":"WinterWheelFitting__description--nbGLX"};